import React from 'react';
import { StanButton } from '@/components';
import { CancellationModalWrapper } from './CancellationModalWrapper';
import { OFFER_MODAL_STRINGS } from '../../constants/cancellationStrings';
import FreeMonthImage from '@/assets/images/cancelation/freeMonth.png';

interface OfferModalProps {
    isOpen: boolean;
    offerType: 'free-month' | 'two-months-discount';
    onAccept: () => void;
    onDecline: () => void;
    isLoading?: boolean;
}

export const OfferModal = ({ isOpen, offerType, onAccept, onDecline, isLoading = false }: OfferModalProps) => {
    const isFreeMonth = offerType === 'free-month';
    const strings = isFreeMonth ? OFFER_MODAL_STRINGS.FREE_MONTH : OFFER_MODAL_STRINGS.TWO_MONTHS_DISCOUNT;

    return (
        <CancellationModalWrapper isOpen={isOpen}>
            <div className='flex flex-col items-center space-y-6 pt-6 text-center'>
                {/* Image */}
                {isFreeMonth && (
                    <div className='w-full max-w-md'>
                        <img src={FreeMonthImage} alt={OFFER_MODAL_STRINGS.FREE_MONTH.IMAGE_ALT} className='w-full' />
                    </div>
                )}

                {/* Title */}
                <div className='space-y-2'>
                    <h2 className='text-heading-heading2 leading-tight'>{strings.TITLE}</h2>
                    <h3 className='text-heading-heading2 leading-tight'>{strings.SUBTITLE}</h3>
                </div>

                {/* Description */}
                <p className='text-body-1-regular text-text-secondary max-w-md'>{strings.DESCRIPTION}</p>

                {/* Buttons */}
                <div className='flex w-full max-w-md flex-col gap-4 pt-4'>
                    <StanButton
                        name='accept-offer-button'
                        size='lg'
                        onClick={onAccept}
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        {strings.ACCEPT_LABEL}
                    </StanButton>
                    <StanButton
                        name='decline-offer-button'
                        variant='link'
                        onClick={onDecline}
                        className='text-brand-main'
                        disabled={isLoading}
                    >
                        {strings.DECLINE_LABEL}
                    </StanButton>
                </div>
            </div>
        </CancellationModalWrapper>
    );
};
